import { ImageType } from "@views/AccountAndSettings/PortalSettings/types";
import { RichText } from "types/entities";

export const checkTextValue = (announcements: string | RichText): string => {
  const textValue =
    typeof announcements === "string"
      ? announcements
      : announcements.html !== announcements.text
        ? announcements.html
        : announcements.text;

  return textValue;
};

export const aspectRatios = {
  [ImageType.LOGO]: 5 / 1,
  [ImageType.DEFAULT_COURSE_AVATAR]: 3 / 2,
  [ImageType.FAVICON]: 1,
};

export const imageAltText = {
  [ImageType.LOGO]: "accountAndSettings.portalSettings.logo",
  [ImageType.DEFAULT_COURSE_AVATAR]: "accountAndSettings.portalSettings.defaultCourseImage",
  [ImageType.FAVICON]: "accountAndSettings.portalSettings.favicon",
};

export const confirmationModalText = {
  [ImageType.LOGO]: {
    headerText: "accountAndSettings.portalSettings.logoDeleteImageHeader",
    bodyTitleText: "accountAndSettings.portalSettings.logoDeleteImageText",
  },
  [ImageType.DEFAULT_COURSE_AVATAR]: {
    headerText: "accountAndSettings.portalSettings.defaultCourseImageDeleteHeader",
    bodyTitleText: "accountAndSettings.portalSettings.defaultCourseImageDeleteText",
  },
  [ImageType.FAVICON]: {
    headerText: "accountAndSettings.portalSettings.faviconDeleteImageHeader",
    bodyTitleText: "accountAndSettings.portalSettings.faviconDeleteImageText",
  },
};
